import { message } from "antd";
import _ from "lodash";
import React from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { getExtPatientConsultation } from "../../../helpers/api";
import { consultationCodeLength } from "../../../helpers/config";
import PatientPortalDetails from "./patient-details";

export default function PatientPortalSearch() {
  const [consultation, setConsultation] = useState({});
  const [code, setCode] = useState("");
  const [hash, setHash] = useState("");
  const [busy, setBusy] = useState(false);
  const params = useParams();

  const findConsultation = (e) => {
    e.preventDefault();
    setHash(params.hash);

    if (!code) {
      message.error("no code found");
      return;
    }
    if (code.length !== consultationCodeLength) {
      message.error("invalid code");
      return;
    }

    fetchConsultation(code);
  };

  const fetchConsultation = (consultationCode) => {
    setBusy(true);

    getExtPatientConsultation(consultationCode, params.hash).then((res) => {
      if (res.status === 200) {
        if (!_.isEmpty(res.data?.data)) {
          setConsultation({
            ...res.data?.data,
            code: consultationCode,
            hash: params.hash,
          });
          // setCode( '' );
        } else message.error("consultation not found");
        // return;
      } else {
        message.error("Request was unsuccessful");
      }

      setBusy(false);
    });
  };

  return (
    <div>
      {_.isEmpty(consultation) ? (
        <div className="row">
          <div className="col-md-7 col-11 mx-auto mt-3">
            <form onSubmit={findConsultation} className="text-center">
              <label className="mb-0" htmlFor="title">
                Enter consultation code
              </label>
              <div className="field">
                <input
                  className="w-50 input text-center"
                  type="text"
                  required
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  autoFocus
                  id="title"
                  placeholder="code here"
                />
              </div>
              <button
                className={`button h6 app-btn btn-prim ${
                  busy && " is-loading"
                }`}>
                Open
              </button>
            </form>
          </div>
        </div>
      ) : (
        <PatientPortalDetails
          data={consultation}
          onClose={() => setConsultation({})}
          onRefresh={() => fetchConsultation(code)}
        />
      )}
    </div>
  );
}
